import React from "react";
import { Layout, Input, message, Row, Col, Spin, Tooltip } from "antd";
import Iconfont from "../../components/Iconfont/Iconfont";
import qiWenLogo from "../../assets/img/qiwenlogo.png";
import bookImg from "../../assets/img/book.png";
import noneData from "../../components/noneData";
import API from "../../api";
import {getSearchParams, responseDataFilter} from "../../utils/tool";
import "./index.scss";
class BookList extends React.Component {
    isLock = false;
    isHaveData = true;
    constructor(props) {
        super(props);
        this.state = {
            // 移动端书籍列表
            dataList: [],
            pageNum: 1,
            isMobile: window.screen.width < 500,

            // PC端书籍列表数据
            sortList: [],
            bookInfo: null,
            bookList: [],
            queryParams: {
                sortId: "1",
                sortBy: "hot",
                pageNum: 1, // 当前页码
            },
        };
    }

    async componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        let queryParams = await this.getSortList();
        this.getBookList(queryParams);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        const {isMobile} = this.state;
        const nowIsMobile = document.documentElement.clientWidth < 500;
        if (isMobile !== nowIsMobile) {
            this.isHaveData = true;
            this.isLock = false;
            this.setState({
                isMobile: nowIsMobile,
                pageNum: 1,
                bookList: [],
                dataList: [],
                queryParams: {
                    sortId: this.getRandomSortId(this.state.sortList),
                    sortBy: "hot",
                    pageNum: 1, // 当前页码
                },
            }, () => {
                this.getBookList();
            });
        }
    }

    toReadPage (url) {
        window.open(url, "_blank");
    }

    // 随机分类
    getRandomSortId (data) {
        if (data && data.length > 0) {
            let idx = Math.floor(Math.random() * data.length);
            return data[idx]?.id; // 随机选中一个分类
        }
    }

    // 获取分类列表
    getSortList = async () => {
        const res = await API.Book.getBookSortList({
            data: {
                pageNum: 1,
                pageSize: 1000,
            },
        });
        const resData = responseDataFilter(res);
        if (resData) {
            let queryParams = {
                ...this.state.queryParams,
                sortId: this.getRandomSortId(resData), // 随机选中一个分类
            };
            this.setState({
                sortList: resData,
                queryParams: queryParams,
            });
            return queryParams;
        }
    }

    // 获取书籍列表
    async getBookList(query) {
        if (!this.isHaveData) {
            return
        }
        const {pageNum, isMobile, queryParams} = this.state;
        let params = {
            pageNum,
            pageSize: 20,
        };
        if (!isMobile) {
            let qp = query || queryParams;
            params = {...qp, belongSortId: qp.sortId, pageSize: 20,};
        }
        const res = await API.Book.getBookList({
            data: {...params, isHaveUrl: true},
            loading: true,
            loadingText: "书籍加载中...",
        });
        const resData = responseDataFilter(res);
        if (resData) {
            let key = "dataList";
            if(!isMobile) {
                key = "bookList";
            }
            let state = {
                [key]: [...this.state[key], ...resData],
            };
            this.isHaveData = state[key].length < res.total;

            this.setState(state, () => {
                this.isLock = false;
                // if (!this.state.bookInfo && resData.length > 0 && key === "bookList") {
                //     let idx = Math.floor(Math.random() * resData.length);
                //     this.selectedBookFunc(resData[idx]);
                // }
            });
        }
    }

    // 滚动加载
    handleScroll = (e) => {
        const { pageNum, isMobile, queryParams} = this.state;
        const {scrollTop, clientHeight, scrollHeight} = e.target;
        const marginBottom = scrollHeight - scrollTop - clientHeight;
        if (!this.isLock && marginBottom < 100) {
            this.isLock = true;
            let state = {
                pageNum: pageNum + 1,
            }
            if (!isMobile) {
                state = {
                    queryParams: {
                        ...queryParams,
                        pageNum: queryParams.pageNum + 1, // pc端分页
                    }
                }
            }
            this.setState(state,() => {
                this.getBookList();
            });
        }
    }

    // pc端查询参数更改触发函数
    queryParamsChangeFunc (key, value) {
        this.isHaveData = true;
        this.setState({
            queryParams: {
                ...this.state.queryParams,
                [key]: value,
                pageNum: 1, // 重置页码
            },
            bookList: [],
            bookInfo: null, // 重置书籍详情
        }, async () => {
            await this.getBookList();
            let dom = document.getElementById("pcBookListScrollBox");
            if (dom) {
                dom.scrollTop = 0; // 滚动到顶部
            }
        });
    }

    // 选中书籍并获取书籍详情
    async selectedBookFunc(bookInfo) {
        this.setState({
            bookInfo: bookInfo,
        }, () => {
            if (bookInfo.url) {
                window.open(bookInfo.url.replaceAll("\\", "/").replaceAll("E:/webstorm_workspacing/qiwen/qiwen-system", ""), "_blank");
            }
        });
    }

    render() {
        const {dataList, isMobile, sortList, bookInfo, bookList, queryParams} = this.state;
        return (
            <div className={`bookListFrame ${isMobile ? "mobileStatus" : ""}`}>
                {/* logo */}
                <div className="logoBox">
                    <img src={qiWenLogo} alt="logo" className="logo"/>
                </div>
                {/* 书籍列表 */}
                {
                    isMobile ?
                        (
                            <div className="bookListBox">
                                <div
                                    className="scrollBox"
                                    onScroll={(e) => {
                                        this.handleScroll(e)
                                    }}
                                >
                                    {
                                        dataList.length > 0 ?
                                            (
                                                <React.Fragment>
                                                    {
                                                        dataList.map((item, index) => {
                                                            return (
                                                                <div className="bookItem" key={index} onClick={() => this.toReadPage(item.url)}>
                                                                    <div className="bookImgBox">
                                                                        <img src={item.bookImg || bookImg} alt={item.keywords} />
                                                                    </div>
                                                                    <div className="bookInfoBox">
                                                                        <span className="bookTitle overflowEllipsis" title={item.bookName}>{item.bookName}</span>
                                                                        <span className="bookDesc" title={item.intro}>{item.intro}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    <div className="bottomTipBox">
                                                        <span className="tipText">亲，已经到底了哦~</span>
                                                    </div>
                                                </React.Fragment>
                                            )
                                            :
                                            (noneData("暂时没有符合搜索条件的书籍"))
                                    }
                                </div>
                            </div>
                        )
                        :
                        (
                            <div className="bookContentBox">
                                <div className="leftBox">
                                    {/* 分类 */}
                                    <div className="sortList">
                                        <div className="sortListBox">
                                            <div
                                                className="scrollBox"
                                                onScroll={(e) => {
                                                    this.handleScroll(e)
                                                }}
                                            >
                                                {
                                                    sortList.map((item, index) => {
                                                        return (
                                                            <div
                                                                className={`sortItem ${queryParams.sortId === item.id ? "selectedStatus" : ""}`}
                                                                key={index}
                                                                onClick={() => this.queryParamsChangeFunc("sortId", item.id)}
                                                            >{item.sortName}</div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {/* 书籍列表 */}
                                    <div className="bookRankAndListBox">
                                        {/* 书籍分榜 */}
                                        <div className="bookRankList"></div>
                                        {/* 书籍列表 */}
                                        <div className="pcBookListBox">
                                            <div
                                                className="scrollBox"
                                                id="pcBookListScrollBox"
                                                onScroll={(e) => {
                                                    this.handleScroll(e)
                                                }}
                                            >
                                                {
                                                    bookList.length > 0 ?
                                                        (
                                                            <React.Fragment>
                                                                <div className="bookItemListBox">
                                                                    {
                                                                        bookList.map((item, index) => {
                                                                            const domId = `book-${item.id}`;
                                                                            return (
                                                                                <Tooltip
                                                                                    title={item.intro}
                                                                                    placement={"right"}
                                                                                    disabled={!item.intro}
                                                                                    key={'intro-'+index}
                                                                                    getPopupContainer={() => document.getElementById(domId)}
                                                                                >
                                                                                    <div
                                                                                        id={domId}
                                                                                        className={`bookItem ${bookInfo?.id === item.id ? "selectedStatus" : ""}`}
                                                                                        key={index}
                                                                                        onClick={() => this.selectedBookFunc(item)}
                                                                                    >
                                                                                        <div className="bookImgBox"><img src={item.bookImg || bookImg} alt=""/></div>
                                                                                        <span className="bookTitle overflowEllipsis" title={item.bookName}>{item.bookName}</span>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                                <div className="bottomTipBox">
                                                                    <span className="tipText">亲，已经到底了哦~</span>
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                        :
                                                        (noneData("该类型的书籍正在补充哦~"))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                }

            </div>
        )
    }
}

export default BookList;
